import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { RestApiService } from 'src/app/core/services/rest-api.service';
import { ApiInterceptor } from 'src/app/core/services/api.interceptor';
import { provideAppConfig } from 'src/app/core/app-config.resolver';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  providers: [
    RestApiService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    provideAppConfig()
  ]
})
export class CoreModule { }
